import { flattenDeep, flatten, findIndex, head, isEmpty, last, find, map } from 'lodash';

import * as constants from './MainModeBook.constants';
import * as services from './MainModeBook.service';
import { getQuestion, markQuestion } from '../../../global/service';
import { setItem, getItem } from '../../../global/storage';

const getVideosByGroup = (Book, groupIdx) =>
  Array.isArray(Book.readingGroupList) &&
  flattenDeep(
    flattenDeep(
      Book.readingGroupList
        .map((v) => {
          if (v.groups[groupIdx]) {
            return v.groups[groupIdx].details;
          } else {
            return [];
          }
        })
        .map((v) => {
          if (v.length == 0) {
            return v;
          }
          const last = v.pop();
          if (last.bullets.length == 0) {
            v.push(last);
            return v;
          }
          const lastBullet = last.bullets.pop();
          lastBullet['endOfReading'] = true;
          last.bullets.push(lastBullet);
          v.push(last);
          return v;
        })
    ).map((v) => v.bullets)
  ).map((v, i, arr) => {
    return {
      courseId: Book.courseId,
      bookId: v.bookId,
      bulletName: v.bulletName,
      bulletId: v.bulletId,
      videoId: v.videoId,
      speed1: v.vpath,
      speed1Dot3: v.vpath_1_3,
      speed1Dot5: v.vpath_1_5,
      speed2: v.vpath_2,
      vpathFree: v.vpathFree,
      freeMode: Book.freeMode,
      isNew: v.newPath ? true : false,
      isLatest: i === arr.length - 1,
      endOfReading: v.endOfReading ? true : false,
      collected: v.collected ? true : false,
      bulletStatus: v.bulletStatus,
      lastProgress: v.lastProgress,
      videoSpeed: v.videoSpeed,
      haveNote: v.haveNote,
      canAccess: v.canAccess,
    };
  });

const addFieldBook = (Book) => {
  return {
    ...Book,
    readingGroupList: map(Book.readingGroupList, (readingGroup) => ({
      ...readingGroup,
      groups: map(readingGroup.groups, (group) => ({
        ...group,
        details: map(group.details, (detail) => ({
          ...detail,
          bullets: map(detail.bullets, (bullet) => {
            const { suggestVideoType, intensiveBullet, ..._bullet } = bullet;
            let bulletPlus = {
              ..._bullet,
              suggestVideoType,
              i_basicBullet: {
                ..._bullet,
              },
              intensiveBullet: null,
            };
            if (intensiveBullet) {
              delete intensiveBullet.suggestVideoType;
              delete intensiveBullet.intensiveBullet;
              bulletPlus = {
                ...bulletPlus,
                intensiveBullet,
              };
              if (2 === suggestVideoType) {
                bulletPlus = {
                  ...bulletPlus,
                  ...intensiveBullet,
                };
              }
            }
            return {
              ...bulletPlus,
              i_selectedVideoType: suggestVideoType,
            };
          }),
        })),
      })),
    })),
  };
};

const state = {
  Book: {},
  BasisVideos: [],
  ReinforceVideos: [],
  ClassicVideos: [],
  ReviewVideos: [],
  ReadyToPlayVideos: [],
  isRequest: false,
  QuestionList: [],
  Question: {},
  BeforePracticeData: {},
  AfterPracticeData: {},
  BeforeChallengeData: {},
  AfterChallengeData: {},
  isBookLevelUp: false,
  isCourseLevelUp: false,
  bookLevelUpTo: 0,
  courseLevelUpTo: 0,
  books: [],
  isHideFileDownLoadTip: getItem(constants.HIDE_FILE_DOWN_LOAD_TIP),
  isInReview: '',
};

const mutations = {
  [constants.GET_BOOK_SUCCESS](state, Book) {
    const points = Book.points.map((v) => ({ ...v, levelUp: false }));
    Book.points = points;
    state.Book = addFieldBook(Book);
    state.BasisVideos = getVideosByGroup(Book, 0);
    state.ReinforceVideos = getVideosByGroup(Book, 1);
    state.ClassicVideos = getVideosByGroup(Book, 2);
    state.ReviewVideos = getVideosByGroup(Book, 3);
    state.LearnpathVideos = getVideosByGroup(state.Book, 4);
    state.ReadyToPlayVideos = state.BasisVideos;
  },

  [constants.CHANGE_VIDEO_TYPE](state, payload) {
    const {
      //
      readingId,
      groupId,
      subjectId,
      bulletId,
      videoType,
    } = payload;
    const readingIdx = findIndex(
      state.Book.readingGroupList,
      (readingGroup) => readingGroup.readingId === readingId
    );
    let readingGroup = state.Book.readingGroupList[readingIdx];
    const groupIdx = findIndex(readingGroup.groups, (group) => group.groupId === groupId);
    let group = readingGroup.groups[groupIdx];
    const subjectIdx = findIndex(group.details, (detail) => detail.subjectId === subjectId);
    let detail = group.details[subjectIdx];
    const bulletIdx = findIndex(
      detail.bullets,
      (bullet) =>
        bullet.bulletId === bulletId ||
        (bullet.i_basicBullet && bullet.i_basicBullet.bulletId === bulletId) ||
        (bullet.intensiveBullet && bullet.intensiveBullet.bulletId === bulletId)
    );
    let bullet = detail.bullets[bulletIdx];
    if (2 === videoType) {
      bullet = {
        ...bullet,
        ...bullet.intensiveBullet,
        i_basicBullet: bullet.i_basicBullet,
        intensiveBullet: bullet.intensiveBullet,
        i_selectedVideoType: videoType,
      };
    } else if (1 === videoType) {
      bullet = {
        ...bullet,
        ...bullet.i_basicBullet,
        i_basicBullet: bullet.i_basicBullet,
        intensiveBullet: bullet.intensiveBullet,
        i_selectedVideoType: videoType,
      };
    }
    detail.bullets.splice(bulletIdx, 1, bullet);
    group.details.splice(subjectIdx, 1, detail);
    readingGroup.groups.splice(groupIdx, 1, group);
    state.Book.readingGroupList.splice(readingIdx, 1, readingGroup);
    state.LearnpathVideos = getVideosByGroup(state.Book, 4);
    state.ReadyToPlayVideos = state.LearnpathVideos;
  },

  [constants.CHANGE_GROUP](state, payload) {
    const { bulletId, groupId } = payload;
    if (31 === groupId) {
      state.ReadyToPlayVideos = state.LearnpathVideos;
    } else {
      const videoInBasis = state.BasisVideos.find((v) => v.bulletId === bulletId);
      const videoInReinforce = state.ReinforceVideos.find((v) => v.bulletId === bulletId);
      const videoInClassic = state.ClassicVideos.find((v) => v.bulletId === bulletId);
      const videoInReview = state.ReviewVideos.find((v) => v.bulletId === bulletId);
      if (videoInBasis) {
        state.ReadyToPlayVideos = state.BasisVideos;
      } else if (videoInReinforce) {
        state.ReadyToPlayVideos = state.ReinforceVideos;
      } else if (videoInClassic) {
        state.ReadyToPlayVideos = state.ClassicVideos;
      } else if (videoInReview) {
        state.ReadyToPlayVideos = state.ReviewVideos;
      }
    }
  },

  [constants.ADD_VIDEO_TO_FAVORITE_LIST](state, bulletId) {
    const index = findIndex(state.ReadyToPlayVideos, (v) => v.bulletId === bulletId);
    if (index != -1) {
      const elem = state.ReadyToPlayVideos[index];
      elem.collected = !elem.collected;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.SET_IS_HIDE_FILE_DOWN_TIP_STATUS](state, status) {
    state.isHideFileDownLoadTip = status;
    setItem(constants.HIDE_FILE_DOWN_LOAD_TIP, status);
  },

  [constants.SET_BOOK_LEVEL_UP_TO](state, level) {
    state.bookLevelUpTo = level;
  },

  [constants.SET_COURSE_LEVEL_UP_TO](state, level) {
    state.courseLevelUpTo = level;
  },

  [constants.SET_BULLET_STATUS](state, { video, status }) {
    const idx = findIndex(state.ReadyToPlayVideos, (v) => v.videoId == video.videoId);
    state.ReadyToPlayVideos[idx].bulletStatus = status;

    const list = state.Book.readingGroupList;

    for (let i = 0, l = list.length; i < l; i++) {
      const groups = list[i].groups;
      for (let ii = 0, ll = groups.length; ii < ll; ii++) {
        const details = groups[ii].details;
        for (let iii = 0, lll = details.length; iii < lll; iii++) {
          const bullets = details[iii].bullets;
          for (let iiii = 0, llll = bullets.length; iiii < llll; iiii++) {
            const bullet = bullets[iiii];
            if (bullet.bulletId == video.bulletId && bullet.videoId == video.videoId) {
              bullet.bulletStatus = status;
              if (bullet.i_basicBullet && bullet.i_basicBullet.bulletId === video.bulletId) {
                bullet.i_basicBullet.bulletStatus = status;
              }
              if (bullet.intensiveBullet && bullet.intensiveBullet.bulletId === video.bulletId) {
                bullet.intensiveBullet.bulletStatus = status;
              }
            }
          }
        }
      }
    }
  },

  [constants.SET_LAST_PROGRESS](state, { videoId, payload }) {
    const index = findIndex(state.ReadyToPlayVideos, (v) => v.videoId === videoId);
    state.ReadyToPlayVideos[index].lastProgress = payload.lastProgress;
    state.ReadyToPlayVideos[index].videoSpeed = payload.videoSpeed;
  },

  [constants.FILE_GENERATED_SUCCESS](state, { fileId, filePath }) {
    for (let i = 0, l = state.Book.files.length; i < l; i++) {
      const file = state.Book.files[i];
      if (file.fileId == fileId) {
        file.filePath = filePath;
      }
    }
  },

  [constants.GET_BEFORE_CHALLENGE_SUCCESS](state, data) {
    state.BeforeChallengeData = data;
  },

  [constants.GET_AFTER_CHALLENGE_SUCCESS](state, data) {
    state.AfterChallengeData = data;
  },

  [constants.GET_BEFORE_PRACTICE_SUCCESS](state, data) {
    state.BeforePracticeData = data;
  },

  [constants.GET_AFTER_PRACTICE_SUCCESS](state, data) {
    state.AfterPracticeData = data;
  },

  [constants.GET_QUESTION_LIST_SUCCESS](state, list) {
    state.QuestionList = list;
  },

  [constants.RESET_QUESTION_LIST_QUESTION_STATUS](state) {
    state.QuestionList = map(state.QuestionList, (question) => ({
      ...question,
      questionStatus: 0,
    }));
  },

  [constants.SET_REVIEW_QUESTION_LIST](state) {
    state.QuestionList = map(state.QuestionList, (question, idx) => ({
      ...question,
      isCurrent: 0 === idx,
    }));
  },

  [constants.SET_IS_IN_REVIEW](state, stepInReview) {
    state.isInReview = stepInReview;
  },

  [constants.UPDATE_PRE_CHALLENGE](state) {
    const payload = {
      correctCount: state.AfterChallengeData.correctQuestions,
      totalCount: state.AfterChallengeData.totalQuestionsCount,
      wrongCount: state.AfterChallengeData.incorrectQuestions,
      startTime: new Date().getTime(),
    };
    state.Book.preChallenge = { ...state.Book.preChallenge, ...payload };
  },

  [constants.UPDATE_SUBJECT_LIST_STATUS](state) {
    const afterList = state.AfterChallengeData.subjectsList;
    if (!afterList || afterList.length === 0) {
      return;
    }

    const filteredList = afterList.filter((v) => v.layerStatus != 0);
    if (filteredList.length === 0) {
      return;
    }

    const list = state.Book.readingGroupList;
    const summary = state.Book.summaryReadings;

    if (state.AfterChallengeData.isCourseLevelUp) {
      state.isCourseLevelUp = true;
      state.courseLevelUpTo = state.AfterChallengeData.courseLevelUpTo;
      state.books = state.AfterChallengeData.bookList;
    } else if (state.AfterChallengeData.isBookLevelUp) {
      state.Book.points = state.AfterChallengeData.points.map((v, i) => {
        if (i + 1 === state.AfterChallengeData.bookLevelUpTo) {
          return {
            ...v,
            levelUp: true,
          };
        } else {
          return {
            ...v,
            levelUp: false,
          };
        }
      });
      state.isBookLevelUp = true;
      state.bookLevelUpTo = state.AfterChallengeData.bookLevelUpTo;
    } else {
      state.Book.points = state.AfterChallengeData.points.map((v) => ({ ...v, levelUp: false }));
    }

    state.Book.points = state.AfterChallengeData.points;
    state.Book.currentPoints = state.AfterChallengeData.bookCurrentPoints;
    state.Book.totalPoints = state.AfterChallengeData.bookTotalPoints;
    state.Book.bookLevel = state.AfterChallengeData.bookLevel;
    state.Book.currentColor = state.AfterChallengeData.currentColor;

    for (let j = 0, k = filteredList.length; j < k; j++) {
      const after = filteredList[j];
      if (!isEmpty(after)) {
        for (let i = 0, l = list.length; i < l; i++) {
          const groups = list[i].groups;
          for (let ii = 0, ll = groups.length; ii < ll; ii++) {
            const details = groups[ii].details;
            for (let iii = 0, lll = details.length; iii < lll; iii++) {
              const questions = details[iii].questions;
              for (let iiii = 0, llll = questions.length; iiii < llll; iiii++) {
                const subject = questions[iiii];
                if (subject.subjectId === after.subjectId) {
                  const obj = Object.assign({}, subject, {
                    currentPoints: after.currentPoints,
                    isCurrent: after.isCurrent,
                    needFinishCount: after.needFinishCount,
                    pointsReachLevel: after.pointsReachLevel,
                    subjectCompletedStatus: after.subjectCompletedStatus,
                  });
                  questions[iiii] = obj;
                }
              }
            }
          }
        }

        for (let i = 0, l = summary.length; i < l; i++) {
          const subjects = summary[i].subjectStatus;
          for (let ii = 0, ll = subjects.length; ii < ll; ii++) {
            if (subjects[ii].subjectId === after.subjectId) {
              subjects[ii].point = after.pointsReachLevel;
            }
          }
        }
      }
    }
  },

  [constants.RESET_BOOK_POINTS](state) {
    const points = state.Book.points.map((v) => {
      return {
        ...v,
        levelUp: false,
      };
    });
    state.Book.points = points;
  },

  [constants.SET_BOOK_LEVEL_UP_STATUS](state, status) {
    state.isBookLevelUp = status;
  },

  [constants.SET_COURSE_LEVEL_UP_STATUS](state, status) {
    state.isCourseLevelUp = status;
  },

  [constants.UPDATE_SUBJECT_STATUS](state) {
    const after = state.AfterPracticeData.afterSubject;
    if (!after || isEmpty(after)) {
      return;
    }
    const list = state.Book.readingGroupList;
    const summary = state.Book.summaryReadings;

    if (state.AfterPracticeData.isCourseLevelUp) {
      state.isCourseLevelUp = true;
      state.courseLevelUpTo = state.AfterPracticeData.courseLevelUpTo;
      state.books = state.AfterPracticeData.bookList;
    } else if (state.AfterPracticeData.isBookLevelUp) {
      state.Book.points = state.AfterPracticeData.points.map((v, i) => {
        if (i + 1 === state.AfterPracticeData.bookLevelUpTo) {
          return {
            ...v,
            levelUp: true,
          };
        } else {
          return {
            ...v,
            levelUp: false,
          };
        }
      });
      state.isBookLevelUp = true;
      state.bookLevelUpTo = state.AfterPracticeData.bookLevelUpTo;
    } else {
      state.Book.points = state.AfterPracticeData.points.map((v) => ({ ...v, levelUp: false }));
    }

    state.Book.currentPoints = state.AfterPracticeData.bookCurrentPoints;
    state.Book.totalPoints = state.AfterPracticeData.bookTotalPoints;
    state.Book.bookLevel = state.AfterPracticeData.bookLevel;
    state.Book.currentColor = state.AfterPracticeData.currentColor;
    console.log(state.Book.currentPoints);
    if (!isEmpty(after)) {
      for (let i = 0, l = list.length; i < l; i++) {
        const groups = list[i].groups;
        for (let ii = 0, ll = groups.length; ii < ll; ii++) {
          const details = groups[ii].details;
          for (let iii = 0, lll = details.length; iii < lll; iii++) {
            const questions = details[iii].questions;
            for (let iiii = 0, llll = questions.length; iiii < llll; iiii++) {
              const subject = questions[iiii];
              if (subject.subjectId === after.subjectId) {
                const obj = Object.assign({}, subject, {
                  currentPoints: after.currentPoints,
                  isCurrent: after.isCurrent,
                  needFinishCount: after.needFinishCount,
                  pointsReachLevel: after.pointsReachLevel,
                  subjectCompletedStatus: after.subjectCompletedStatus,
                });
                questions[iiii] = obj;
              }
            }
          }
        }
      }

      for (let i = 0, l = summary.length; i < l; i++) {
        const subjects = summary[i].subjectStatus;
        for (let ii = 0, ll = subjects.length; ii < ll; ii++) {
          if (subjects[ii].subjectId === after.subjectId) {
            subjects[ii].point = after.pointsReachLevel;
          }
        }
      }
    }
  },

  [constants.GET_QUESTION_SUCCESS](state, question) {
    if (isEmpty(question)) {
      state.Question = question;
    } else {
      let isLatest = false;
      if (question.questionId === last(state.QuestionList).questionId) {
        isLatest = true;
      }
      const q = find(
        state.QuestionList,
        (q) => q.questionId === question.questionId
      );
      state.Question = {
        ...question,
        isAnswered: Boolean(state.isInReview), //false,
        isSubmitted: Boolean(state.isInReview), //false,
        isLatest,
        selectedOption: state.isInReview && q.studentAnswer ? q.studentAnswer : '', //: question.questionType.indexOf('QA') !== -1 ? 'done' : '',
      };
      if (q.questionLanguage === question.questionLanguage) {
        state.Question = {
          ...state.Question,
          detail: {
            ...question.detail,
            imageQuestionHtml: q.imageQuestionHtml
              ? q.imageQuestionHtml
              : question.detail.imageQuestionHtml,
            imageOption0Html: q.imageOption0Html ? q.imageOption0Html : question.detail.imageOption0Html,
          },
        };
      }
      if (question.qType === 'xl') {
        const subQuestions = question.subQuestions;
        state.Question = {
          ...state.Question,
          isInSubQuestions: true,
          pos: 0,
          subQuestions: subQuestions.map((v, i) => ({
            ...v,
            isAnswered: false,
            isSubmitted: false,
            selectedOption: state.isInReview && v.studentAnswer ? v.studentAnswer : '', //: v.questionType.indexOf('QA') !== -1 ? 'done' : '',
            isLatest: i === subQuestions.length - 1,
          })),
        };
        if (q.questionLanguage === question.questionLanguage && q.subQuestion) {
          state.Question = {
            ...state.Question,
            subQuestions: state.Question.subQuestions.map((v, i) => {
              if (q.subQuestion[i]) {
                return {
                  ...v,
                  detail: {
                    ...v.detail,
                    imageQuestionHtml: q.subQuestion[i].imageQuestionHtml
                      ? q.subQuestion[i].imageQuestionHtml
                      : v.detail.imageQuestionHtml,
                    imageOption0Html: q.subQuestion[i].imageOption0Html ? q.subQuestion[i].imageOption0Html : v.detail.imageOption0Html,
                  },
                }
              } else {
                return v;
              }
            }),
          };
        }
      }
    }
  },

  [constants.UPDATE_QUESTION_HTML_SUCCESS](state, question) {
    if (isEmpty(question)) {
      state.Question = question;
    } else {
      state.Question = {
        ...state.Question,
        detail: {
          ...state.Question.detail,
          imageExplainHtml: question.detail.imageExplainHtml,
          imageOption0Html: question.detail.imageOption0Html,
          imageOptionaHtml: question.detail.imageOptionaHtml,
          imageOptionbHtml: question.detail.imageOptionbHtml,
          imageOptioncHtml: question.detail.imageOptioncHtml,
          imageOptiondHtml: question.detail.imageOptiondHtml,
          imageOptioneHtml: question.detail.imageOptioneHtml,
          imageQuestionHtml: question.detail.imageQuestionHtml,
        },
      };
      if (question.qType === 'xl') {
        const subQuestions = question.subQuestions;
        state.Question = {
          ...state.Question,
          subQuestions: subQuestions.map((v, i) => ({
            ...state.Question.subQuestions[i],
            detail: {
              ...state.Question.subQuestions[i].detail,
              imageExplainHtml: v.detail.imageExplainHtml,
              imageOption0Html: v.detail.imageOption0Html,
              imageOptionaHtml: v.detail.imageOptionaHtml,
              imageOptionbHtml: v.detail.imageOptionbHtml,
              imageOptioncHtml: v.detail.imageOptioncHtml,
              imageOptiondHtml: v.detail.imageOptiondHtml,
              imageOptioneHtml: v.detail.imageOptioneHtml,
              imageQuestionHtml: v.detail.imageQuestionHtml,
            },
          })),
        };
      }
    }
  },

  [constants.SAVE_QUESTION_RANGY_MARK](state, payload) {
    const {
      imageQuestionHtml,
      imageOption0Html,
      largeHtml,
      isCurrentQuestionXL,
      currentQuestionId,
      currentSubQuestionIdx,
      questionLanguage,
    } = payload;
    const currentQuestionIdx = _.findIndex(state.QuestionList, (question) => question.questionId === currentQuestionId);
    const question = state.QuestionList[currentQuestionIdx];
    if (isCurrentQuestionXL && -1 !== currentQuestionIdx && -1 !== currentSubQuestionIdx) {
      if (!question.subQuestion) {
        question.subQuestion = [];
      }
      if (!question.subQuestion[currentSubQuestionIdx]) {
        question.subQuestion[currentSubQuestionIdx] = {};
      }
      const subQuestion = question.subQuestion[currentSubQuestionIdx];
      subQuestion.imageQuestionHtml = imageQuestionHtml;
      subQuestion.imageOption0Html = imageOption0Html;
      question.imageQuestionHtml = largeHtml;
    } else {
      question.imageQuestionHtml = imageQuestionHtml;
      question.imageOption0Html = imageOption0Html;
    }
    question.questionLanguage = questionLanguage;
  },

  [constants.QUESTION_SUBMITTED_SUCCESS](state) {
    if (state.Question.qType !== 'xl') {
      state.Question = { ...state.Question, isSubmitted: true };
    } else {
      const subQuestions = state.Question.subQuestions;
      const question = subQuestions[state.Question.pos];
      question.isSubmitted = true;
    }
  },

  [constants.ANSWER_SUCCESS](state, { questionStatus, studentAnswer }) {
    const deltaCorrectCount = questionStatus === 1 ? 1 : 0;
    const deltaWrongCount = questionStatus === 1 ? 0 : 1;
    if (state.Question.qType !== 'xl') {
      state.Question = {
        ...state.Question,
        isAnswered: true,
        correctCount: state.Question.correctCount + deltaCorrectCount,
        wrongCount: state.Question.wrongCount + deltaWrongCount,
        personalCorrectCount: state.Question.personalCorrectCount + deltaCorrectCount,
        personalWrongCount: state.Question.personalWrongCount + deltaWrongCount,
      };
      const idx = findIndex(state.QuestionList, { questionId: state.Question.questionId });
      if (idx != -1) {
        state.QuestionList[idx].questionStatus = questionStatus;
        state.QuestionList[idx].studentAnswer = studentAnswer;
      }
    } else {
      const subQuestions = state.Question.subQuestions;
      const question = subQuestions[state.Question.pos];
      question.isAnswered = true;
      question.isCorrect = questionStatus === 1 ? true : false;
      question.correctCount = question.correctCount + deltaCorrectCount;
      question.wrongCount = question.wrongCount + deltaWrongCount;
      question.personalCorrectCount = question.personalCorrectCount + deltaCorrectCount;
      question.personalWrongCount = question.personalWrongCount + deltaWrongCount;
      const nonAnsweredArr = subQuestions.filter((v) => v.isAnswered === false);
      const isCorrectArr = subQuestions.filter((v) => !v.isCorrect);
      if (nonAnsweredArr.length === 0) {
        state.Question = {
          ...state.Question,
          isAnswered: true,
        };
      }
      const idx = findIndex(state.QuestionList, { questionId: state.Question.questionId });
      if (idx != -1 && nonAnsweredArr.length === 0) {
        if (isCorrectArr.length === 0) {
          state.QuestionList[idx].questionStatus = 1;
        } else {
          state.QuestionList[idx].questionStatus = -1;
        }
      }
    }
  },

  [constants.MARK_QUESTION_SUCCESS](state, isMarked) {
    if (state.Question.qType !== 'xl' || !state.Question.isInSubQuestions) {
      state.Question = {
        ...state.Question,
        isMarked,
      };
    } else {
      const question = state.Question.subQuestions[state.Question.pos];
      question.isMarked = isMarked;
    }
  },

  [constants.SET_QUESTION](state, payload) {
    if (state.Question.qType !== 'xl') {
      if (state.Question.noDefiniteQuestion) {
        let options = state.Question.selectedOption;
        const { selectedOption } = payload;
        options.indexOf(selectedOption) !== -1
          ? (state.Question = {
            ...state.Question,
            selectedOption: options.replace(selectedOption, ''),
          })
          : (state.Question = {
            ...state.Question,
            selectedOption: `${options}${selectedOption}`.split('').sort().join(''),
          });
      } else {
        state.Question = {
          ...state.Question,
          ...payload,
        };
      }
    } else {
      const { selectedOption } = payload;
      if (selectedOption) {
        if (state.Question.subQuestions[state.Question.pos].noDefiniteQuestion) {
          let options = state.Question.subQuestions[state.Question.pos].selectedOption;
          if (options.indexOf(selectedOption) !== -1) {
            state.Question.subQuestions[state.Question.pos].selectedOption = options.replace(
              selectedOption,
              ''
            );
          } else {
            state.Question.subQuestions[
              state.Question.pos
            ].selectedOption = `${options}${selectedOption}`.split('').sort().join('');
          }
        } else {
          state.Question.subQuestions[state.Question.pos].selectedOption = selectedOption;
        }
      } else {
        state.Question = {
          ...state.Question,
          ...payload,
        };
      }
    }
  },

  [constants.NOTE_SAVED_SUCCESS](state, payload) {
    if (state.Question.qType !== 'xl') {
      state.Question.haveNote = payload.flag;
      const idx = findIndex(state.QuestionList, { questionId: payload.Question.questionId });
      state.QuestionList[idx].haveNote = payload.flag;
    } else {
      state.Question.subQuestions[state.Question.pos].haveNote = payload.flag;
      const haveNote = state.Question.subQuestions.filter((v) => v.haveNote);
      const idx = findIndex(state.QuestionList, { questionId: payload.Question.questionId });
      if (haveNote.length) {
        state.QuestionList[idx].haveNote = true;
      } else {
        state.QuestionList[idx].haveNote = false;
      }
    }
  },
};

const actions = {
  noteSaved({ commit }, payload) {
    commit(constants.NOTE_SAVED_SUCCESS, payload);
  },

  async getBook({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    try {
      const res = await services.getBook(payload);
      commit(constants.GET_BOOK_SUCCESS, res.data.data);
      commit(constants.SET_IS_REQUEST_STATUS, false);
    } catch (e) {
      commit(constants.SET_IS_REQUEST_STATUS, false);
    }
  },

  async addToFavoriteList({ commit }, payload) {
    const res = await services.addToFavoriteList(payload);
    if (res.data.data) {
      commit(constants.ADD_VIDEO_TO_FAVORITE_LIST, payload.bulletId);
    }
  },

  async getAfterChallenge({ commit }, payload) {
    const res = await services.getAfterChallenge(payload);
    commit(constants.GET_AFTER_CHALLENGE_SUCCESS, res.data.data);
    commit(constants.UPDATE_PRE_CHALLENGE);
  },

  async getBeforeChallenge({ commit }, payload) {
    const res = await services.getBeforeChallenge(payload);
    commit(constants.GET_BEFORE_CHALLENGE_SUCCESS, res.data.data);
  },

  async _getChallengeQuestion({ commit, rootGetters }, payload) {
    const { question } = payload;
    if (question) {
      const questionRes = await getQuestion(payload.courseId, question.questionId);
      commit(constants.GET_QUESTION_SUCCESS, {
        ...questionRes.data.data,
        questionLanguage: rootGetters.userInfo.profile.questionLanguage,
      });
    } else {
      commit(constants.GET_QUESTION_SUCCESS, {});
    }
    if ('toQuestion' === payload.stepInReview) {
      commit(constants.SET_IS_IN_REVIEW, 'question');
    }
  },

  async getChallenge({ dispatch, commit }, payload) {
    const res = await services.getChallenge(payload);
    // console.log(res.data.data);
    const data = [...res.data.data];
    const current = find(data, { isCurrent: true });
    let question = {};
    if (!current) {
      question = head(data);
    } else {
      question = { ...current };
    }
    commit(constants.GET_QUESTION_LIST_SUCCESS, res.data.data);
    dispatch('_getChallengeQuestion', {
      ...payload,
      question,
    });
  },

  _setReviewChallengeData({ dispatch, commit, state }, payload) {
    let question = {};
    if (state.QuestionList && state.QuestionList.length > 0) {
      question = head(state.QuestionList);
    }
    commit(constants.SET_REVIEW_QUESTION_LIST);
    dispatch('_getChallengeQuestion', {
      ...payload,
      question,
    });
  },

  setIsInReview({ dispatch, commit }, payload) {
    commit(constants.SET_IS_IN_REVIEW, payload.stepInReview);
    if ('toQuestion' === payload.stepInReview) {
      dispatch('_setReviewChallengeData', payload);
    }
  },

  async tsChallenge({ commit }, payload) {
    await services.tsChallenge(payload);
    commit(constants.GET_QUESTION_LIST_SUCCESS, []);
    commit(constants.GET_QUESTION_SUCCESS, {});
    commit(constants.GET_BEFORE_CHALLENGE_SUCCESS, {});
    commit(constants.GET_AFTER_CHALLENGE_SUCCESS, {});
  },

  async getAfterPractice({ commit }, payload) {
    const res = await services.getAfterPractice(payload);
    commit(constants.GET_AFTER_PRACTICE_SUCCESS, res.data.data);
  },

  async getBeforePractice({ commit }, payload) {
    const res = await services.getBeforePractice(payload);
    commit(constants.GET_BEFORE_PRACTICE_SUCCESS, res.data.data);
  },

  async _getPractice({ commit, rootGetters }, srvcPayload) {
    const { services, payload } = srvcPayload;
    const res = await services.getPractice(payload);
    const question = head(res.data.data);
    commit(constants.GET_QUESTION_LIST_SUCCESS, res.data.data);
    if (question) {
      const questionRes = await getQuestion(payload.courseId, question.questionId);
      commit(constants.GET_QUESTION_SUCCESS, {
        ...questionRes.data.data,
        questionLanguage: rootGetters.userInfo.profile.questionLanguage,
      });
    } else {
      commit(constants.GET_QUESTION_SUCCESS, {});
    }
  },

  async getPractice({ dispatch }, payload) {
    const srvcPayload = {
      services: {
        getPractice: services.getPractice,
      },
      payload,
    };
    await dispatch('_getPractice', srvcPayload);
  },

  async getQuestionListType({ dispatch, commit }, payload) {
    const srvcPayload = {
      services: {
        getPractice: services.getQuestionListType,
      },
      payload,
    };
    await dispatch('_getPractice', srvcPayload);
    commit(constants.RESET_QUESTION_LIST_QUESTION_STATUS);
  },

  async answer({ commit, state }, payload) {
    let param = {};
    if (state.Question.qType !== 'xl') {
      if (state.Question.questionType.indexOf('OP') !== -1) {
        param = {
          ...payload,
          questionId: state.Question.questionId,
          questionStatus: state.Question.answer === state.Question.selectedOption ? 1 : -1,
          studentAnswer: state.Question.selectedOption,
        };
      } else if (state.Question.questionType.indexOf('QA') !== -1) {
        param = {
          ...payload,
          questionId: state.Question.questionId,
          questionStatus: 1,
          //studentAnswer: 'done',
        };
      }
    } else {
      const question = state.Question.subQuestions[state.Question.pos];
      if (question.questionType.indexOf('OP') !== -1) {
        param = {
          ...payload,
          questionId: question.questionId,
          questionStatus: question.answer === question.selectedOption ? 1 : -1,
          studentAnswer: question.selectedOption,
        };
      } else if (question.questionType.indexOf('QA') !== -1) {
        param = {
          ...payload,
          questionId: question.questionId,
          questionStatus: 1,
          //studentAnswer: 'done',
        };
      }
    }
    commit(constants.ANSWER_SUCCESS, param);
    await services.answer(param);
    commit(constants.QUESTION_SUBMITTED_SUCCESS);
  },

  async getQuestion({ commit, rootGetters }, payload) {
    const questionRes = await getQuestion(payload.courseId, payload.questionId);
    commit(constants.GET_QUESTION_SUCCESS, {
      ...questionRes.data.data,
      questionLanguage: rootGetters.userInfo.profile.questionLanguage,
    });
  },

  async updateQuestionHtml({ commit }, payload) {
    const questionRes = await getQuestion(payload.courseId, payload.questionId);
    commit(constants.UPDATE_QUESTION_HTML_SUCCESS, questionRes.data.data);
  },

  async markQuestion({ commit }, { courseId }) {
    let param = {};
    if (state.Question.qType !== 'xl' || !state.Question.isInSubQuestions) {
      param = {
        markStatus: !state.Question.isMarked,
        isMark: state.Question.isMarked ? 0 : 1,
        questionId: state.Question.questionId,
        _type: 0,
        courseId,
      };
    } else {
      const question = state.Question.subQuestions[state.Question.pos];
      param = {
        markStatus: !question.isMarked,
        isMark: question.isMarked ? 0 : 1,
        questionId: question.questionId,
        _type: 0,
        courseId,
      };
    }
    const res = await markQuestion(param);
    if (res.data.status == 200) {
      commit(constants.MARK_QUESTION_SUCCESS, param.markStatus);
    }
  },

  async generateFile({ commit }, payload) {
    const res = await services.generateFile(payload);
    commit(constants.FILE_GENERATED_SUCCESS, { ...payload, filePath: res.data.data });
  },
};

const getters = {
  isLockedByStudentWorkStatus: (state) => {
    return state.Book.studentWorkEntity && 0 === state.Book.studentWorkEntity.studentWorkStatus;
  },

  Book: (state, getters) => {
    const isLockedByStudentWorkStatus = getters.isLockedByStudentWorkStatus;
    return {
      ...state.Book,
      c_isLockedByStudentWorkStatus: isLockedByStudentWorkStatus,
      c_isCanStudy: state.Book.canAccess && !isLockedByStudentWorkStatus,
    };
  },

  BasisVideos: (state) => state.BasisVideos,
  ReinforceVideos: (state) => state.ReinforceVideos,
  ClassicVideos: (state) => state.ClassicVideos,
  ReviewVideos: (state) => state.ReviewVideos,
  ReadyToPlayVideos: (state) => state.ReadyToPlayVideos.filter((v) => v.canAccess),
  isRequest: (state) => state.isRequest,
  Question: (state) => state.Question,
  QuestionList: (state) => state.QuestionList,
  BeforePracticeData: (state) => state.BeforePracticeData,
  AfterPracticeData: (state) => state.AfterPracticeData,
  BeforeChallengeData: (state) => state.BeforeChallengeData,
  AfterChallengeData: (state) => state.AfterChallengeData,
  isBookLevelUp: (state) => state.isBookLevelUp,
  isCourseLevelUp: (state) => state.isCourseLevelUp,
  bookLevelUpTo: (state) => state.bookLevelUpTo,
  courseLevelUpTo: (state) => state.courseLevelUpTo,
  books: (state) => state.books,
  isHideFileDownLoadTip: (state) => state.isHideFileDownLoadTip,
  hasCurrentReading: (state) => {
    if (Array.isArray(state.Book.readingGroupList)) {
      const current = state.Book.readingGroupList.find((v) => v.isCurrent);
      if (current) {
        return current;
      } else {
        return state.Book.readingGroupList[0];
      }
    }
  },
  lastTimeGroupBulletId: (state, getters) => {
    if (getters.hasCurrentReading.isCurrent) {
      const lastTimeReading = getters.hasCurrentReading;
      const lastTimeGroup = find(lastTimeReading.groups, (group) => group.active);
      if (lastTimeGroup) {
        const lastTimeGroupBullets = flatten(
          map(lastTimeGroup.details, (detail) => detail.bullets)
        );
        const lastTimeBullet = find(lastTimeGroupBullets, (bullet) => bullet.isCurrent);
        if (lastTimeBullet) {
          return {
            groupId: lastTimeGroup.groupId,
            bulletId: lastTimeBullet.bulletId,
          };
        }
      }
    }
    return {
      groupId: -1,
      bulletId: -1,
    };
  },
  isInReview: (state) => state.isInReview,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
